import React from 'react';

export function AlertOctagon () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g
        stroke="#EF374E"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#clip0_16377_8650)"
      >
        <path d="M5.24 1.333h5.52l3.907 3.907v5.52l-3.907 3.907H5.24L1.333 10.76V5.24L5.24 1.333zM8 5.333V8M8 10.667h.007" />
      </g>
      <defs>
        <clipPath id="clip0_16377_8650">
          <path fill="#fff" d="M0 0H16V16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
